import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { EUserRole } from 'common/const/enum';
import { getFormattedTime } from 'common/helpers';
import { IEventAvailableOperationsParams, IEventListItem } from 'entities/Events/Event.models';
import { EEventStatus, EEventType, EEventTypeLabel } from 'entities/Events/Event.enum';

export const renderEventListRecords = (status?: string) => {
  return [
    {
      title: 'Date',
      dataIndex: 'createdAt',
      sorter: true,
      render: (_, record) => dayjs(record.createdAt).format('D MMM, hh:mma'),
    },
    {
      title: 'Patient name',
      dataIndex: 'patientName',
      sorter: true,
    },
    {
      title: 'Type',
      render: (_, record) => EEventTypeLabel[record.type],
    },
    {
      title: 'Event Age',
      render: (_, record) => {
        if (status === EEventStatus.Completed) {
          return getFormattedTime(dayjs(record.completedAt).diff(record.createdAt), 'ddd hhh mmm sss');
        } else {
          return getFormattedTime(dayjs().diff(record.createdAt), 'ddd hhh mmm sss');
        }
      },
    },
  ] as ColumnsType<IEventListItem>;
};

export const getEventAvailableOperations = (params: IEventAvailableOperationsParams) => {
  const { status, type, role, currentUserId, staffId, physicianId } = params;

  let canReview = false;
  let canStart = false;
  let autoStart = false;
  let blockRouter = false;
  let canBeMovedToInbox = false;
  let canBeCompleted = false;
  let canCall = false;

  if (status === EEventStatus.Inbox) {
    canReview = true;
  }

  if (role === EUserRole.Physician && status === EEventStatus.UnderReview && !physicianId) {
    canReview = true;
  }

  if (role === EUserRole.Staff && (currentUserId === staffId || !staffId) && status === EEventStatus.UnderReview) {
    canReview = true;
    canStart = true;
    autoStart = true;
    blockRouter = true;
    canBeMovedToInbox = true;
    canBeCompleted = true;
  }

  if (role === EUserRole.Physician && currentUserId === physicianId && status === EEventStatus.UnderReview) {
    canReview = true;
    canStart = true;
    autoStart = true;
    blockRouter = true;
    canBeMovedToInbox = true;
    canBeCompleted = true;
  }

  if (role === EUserRole.Staff && currentUserId === staffId && type === EEventType.Lucy) {
    canCall = true;
  }

  if (role === EUserRole.Physician && currentUserId === physicianId && type === EEventType.Lucy) {
    canCall = true;
  }

  return { canReview, canStart, autoStart, blockRouter, canBeMovedToInbox, canBeCompleted, canCall };
};
